<template>
      <div style="width:1300px;margin:0 auto;font-size:13px;">
           <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:30px;">
                <p class="text-center mb-2">
                     <span style="font-size:15px;">
                       周记审阅
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
             <div style="text-align:right;" class="mb-1">
                    <button class="btn btn-primary" :class="{active_kan:kanlog==0}" @click="getBlog(1,0)">
                         未审阅的周记
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==1}" @click="getBlog(1,1)">
                         已审阅的周记
                    </button>
               </div>
                   <div v-show="BlogList.length>0">
                    <table class="table table-striped table-hover" ref="print">
                        <thead>
                                <tr style="white-space: nowrap;">
                                     <th class="text-center">标题</th>
                                     <th class="text-center">时间</th>
                                     <th class="text-center">作者</th>
                                     <!-- <th class="text-center">状态</th> -->
                                     <!-- <th class="text-center">公示</th> -->
                                     <th class="text-center">操作</th>
                               </tr>
                        </thead>
                        <tbody>
                                 <tr v-for="(item,index) in BlogList" :key="index">
                                                            <td class="text-center jz_middle" style="color:green">{{item.title}}</td>
                                                            <td class="text-center jz_middle">{{item.inserttime}}</td>
                                                            <td class="text-center jz_middle" style="color:#f4930a">{{item.truename}}</td>
                                                            <!-- <td class="text-center jz_middle" style="color:#36d">{{item.state | getState}}</td> -->
                                                            <!-- <td class="text-center jz_middle" style="color:red">{{item.publicity | gongShi}}</td> -->
                                                            <td class="text-center jz_middle">
                                                                 <!-- <button class="btn btn-primary" @click="goLog(item.id)">公示</button> -->
                                                                 <!-- <button class="btn btn-info" @click="reject(item.id)">驳回</button> -->
                                                                 <button class="btn btn-success" @click="revert(item.id)">批阅</button>
                                                                  <button class="btn btn-primary" @click="getLog(item.id)">查看</button>
                                                            </td>
                                 </tr>
                        </tbody>
                 </table>
                         <div>
                                                  <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>

                         </div>

                 </div>
                 <div v-show="record===0" class="text-center">
                     <img src="../../../static/images/timg.jpg" alt="">
                </div>
           </div>
      </div>
</template>

<script>
import vPagination from "../../components/Pagination.vue";
export default {
      data(){
          return{
              BlogList:[],
              lxs:'',
              state:'',
              pageIndex:'',
              username:'',
              contents:'',
              id:'',
              title:'',
              reply:'',
              record:'',
              kanlog:'',

            total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

               
          }
      },
      components:{
           vPagination,
      },
    filters: {
      getState:function(result) {
            switch(result){
               case 0: 
               return "未审阅";
               case 1:
               return "已审阅";
               case 2:
               return "驳回";
               case 3:
               return "删除";
            }
             
        } ,
     gongShi:function(gongShi){
           if(gongShi==1){
                return '已公示'
           }
           else{
                return '未公示'
           }
     },
        changeTitle:function(title){
                    return title.substring(22)
        },
   },
      methods:{

            pagechange:function(currentPage){
                 this.changeBlog(currentPage);
     },

           
           //分页日志
           changeBlog(currentPage){
               //  
                const that=this;
                that.state=that.state;
                this.getBlog(currentPage,that.state);

           },
          //获取日志
        getBlog: async function (pageIndex,state) {
             this.state=state;
             if(state==1){
                  this.kanlog=1;
             }
             else{
                  this.kanlog=0;
             }
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkGetBlog',
          obj: JSON.stringify({
               lxs:2,
               state,
               pageIndex,
               lx:1,
          })
        })
     //    
        if (res.isok) {
             if(res.data.isok){
                  const obj = res.data
                  this.record = obj.record
                  this.BlogList = obj.rows2
                  this.total = obj.totalCount
              
                  
             }
             else{
                  alert(res.data.msg);
             }
        }
        else{
             alert(res.message);
        }
      },
       //驳回日志
     //   reject:async function(id){
     //      const { data: res } = await this.$http.post('Dls/getFun', {
     //      action: 'ClerkUpBlog',
     //      obj: JSON.stringify({
     //            lxs:'3',
     //            state:'2',
     //            id,
     //      })
     //    })
     // //    
     //    if (res.isok){
     //          if(res.data.isok){
     //                this.$message.success(res.data.msg)
     //                const obj = res.data
     //          }
     //    }
     //   },

       //公示日志
       goLog(id){
            this.$router.push({path: '/getLog', query:{id:id}})
       },
        getLog(id){
            this.$router.push({path: '/lookLog', query:{id:id}})
       },
       //回复日志
       revert(id){
            this.$router.push({path:'/replay',query:{id:id}})
       }
     
      },
      created(){
          this.getBlog(1,0);
      }
}
</script>

<style lang="less" scoped>
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .active_kan{
      color:red;
 }

</style>




// WEBPACK FOOTER //
// src/components/weeklyReport/WeekCheck.vue